import { render } from "./Indicator.vue?vue&type=template&id=37579fba&scoped=true"
import script from "./Indicator.vue?vue&type=script&lang=js"
export * from "./Indicator.vue?vue&type=script&lang=js"

import "./Indicator.vue?vue&type=style&index=0&id=37579fba&scoped=true&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37579fba"]])

export default __exports__